import {React} from 'common'
import {useI18n} from 'store/Store'
import {styled} from '@mui/material'
import {Colors, Texts} from 'appearance'
import analyticsService from 'services/analytic'

const LoginTitle = ({
    showSmsVerification,
    setShowSmsVerification,
    username,
    isMobile,
}) => {
    const {i18n} = useI18n()

    return (
        <Container isMobile={isMobile}>
            <Title>
                {showSmsVerification
                    ? i18n.t('register.smsVerificationText', {
                          phone: username,
                      })
                    : i18n.t('header.title')}
            </Title>
            {showSmsVerification ? (
                <ChangePhone
                    onClick={() => {
                        setShowSmsVerification(false)
                        analyticsService.verificationExistingUserPressedChangeNumber()
                    }}>
                    {i18n.t('login.changePhone')}
                </ChangePhone>
            ) : (
                <Subtitle>{i18n.t('login.subtitle')}</Subtitle>
            )}
        </Container>
    )
}

export default LoginTitle

const Container = styled('div')`
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-top: ${({isMobile}) => (isMobile ? 80 : 0)}px;
`

const Title = styled(Texts.BoldText)`
    font-size: 28px;
    color: ${Colors.PRIMARY_TEXT};
    margin-bottom: 12px;
`

const Subtitle = styled(Texts.RegularText)`
    color: rgba(149, 150, 154, 1);
    font-size: 20px;
    font-weight: 400;
`
const ChangePhone = styled(Texts.RegularText)`
    color: ${Colors.LINK_TEXT};
    text-decoration: underline;
`
